import { SetupGuideProvider } from "./SetupGuideContext";
import { SetupGuideDrawer } from "./SetupGuideDrawer";
import { GuideHint } from "./hints/GuideHint";

function SetupGuideChrome() {
  return (
    <>
      <SetupGuideDrawer />
      <GuideHint />
    </>
  );
}

export function SetupGuideRoot({ children }) {
  return (
    <SetupGuideProvider>
      <SetupGuideChrome />
      {children}
    </SetupGuideProvider>
  );
}
